module.exports = __webpack_public_path__ + "img/sillustani.e64b4e64.jpg";